import { DatabaseFieldType, RenderContext } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import type { FieldType } from '../field-types';

const unreachable = (value: never) => {
  throw new Error(`Not implemented: ${value}`);
};

const checkboxFieldType: FieldType<DatabaseFieldType.CHECKBOX> = {
  supportedFilterTypes: [DatabaseFilterType.EQUALS],
  isCsvImportSupported: true,
  renderExportView: ({ value }, _state, renderContext) => {
    switch (renderContext) {
      case RenderContext.EXPORT_DATABASE:
      case RenderContext.PRINT_PREVIEW:
        return `${value ? '☑' : '☐'}`;
      case RenderContext.COPY_DATABASE_TO_CLIPBOARD:
        return `${value}`;
      default:
        return unreachable(renderContext);
    }
  },
  parseFromHtml: (el) => {
    const textContent = el.text();
    return textContent === 'true';
  },
  getInitialValue: () => false,
  isEmptyValue: () => false, // a checkbox is never empty. there is no way to differentiate between an untouched checkbox or one unchecked.
  isEqualValue: ({ value: value1 }, { value: value2 }) => value1 === value2,
  getStringRepresentation: ({ value }) => `${value}`,
  convertTo: {
    [DatabaseFieldType.TEXT]: (context) => ({
      plain: `${context.value}`
    })
  },
  convertFrom: {
    [DatabaseFieldType.TEXT]: (context) => context.value.plain.toLowerCase() === 'true',
    [DatabaseFieldType.SELECT]: (context) => {
      const selectedOptions = context.field.settings.selectOptions.filter((op) =>
        context.value.includes(op.id ?? op.label)
      );
      if (selectedOptions.length === 1) {
        const label = selectedOptions[0].label.toLowerCase();
        if (label === 'true') {
          return true;
        }
      }
      return false;
    }
  }
};
export default checkboxFieldType;
